"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.element = element;
exports.removeAllChildren = removeAllChildren;
exports.div = div;
exports.img = img;
exports.input = input;
exports.span = span;
exports.style = style;
exports.table = table;
exports.a = a;
exports.tr = tr;
exports.td = td;
exports.button = button;
exports.slot = slot;
exports.select = select;
exports.option = option;
exports.hr = hr;
function element(name, parent, className) {
    const e = document.createElement(name);
    if (className)
        e.className = className;
    parent.appendChild(e);
    return e;
}
function removeAllChildren(e) {
    while (e.firstChild) {
        e.removeChild(e.firstChild);
    }
}
function div(parent, className) {
    return element('div', parent, className);
}
function img(parent, className) {
    return element('img', parent, className);
}
function input(parent, className) {
    return element('input', parent, className);
}
function span(parent, className) {
    return element('span', parent, className);
}
function style(parent, className) {
    return element('style', parent, className);
}
function table(parent, className) {
    return element('table', parent, className);
}
function a(parent, url, className) {
    const link = element('a', parent, className);
    if (url !== null) {
        link.setAttribute('href', url);
    }
    return link;
}
function tr(parent, className) {
    return element('tr', parent, className);
}
function td(parent, className) {
    return element('td', parent, className);
}
function button(parent, className) {
    return element('button', parent, className);
}
function slot(parent, className) {
    return element('slot', parent, className);
}
function select(parent, className) {
    return element('select', parent, className);
}
function option(parent, className) {
    return element('option', parent, className);
}
function hr(parent, className) {
    return element('hr', parent, className);
}
